import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
interface ToastProps {
  message: string;
  isVisible: boolean;
  onDismiss: () => void;
}
export function Toast({
  message,
  isVisible,
  onDismiss
}: ToastProps) {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onDismiss();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onDismiss]);
  return <AnimatePresence data-id="element-693">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} transition={{
      duration: 0.2
    }} className="fixed bottom-20 left-1/2 transform -translate-x-1/2 z-50 max-w-lg w-full px-4" data-id="element-694">
          <div className="bg-gray-900 text-white px-4 py-3 rounded-lg shadow-lg flex items-center justify-center" data-id="element-695">
            <CheckCircleIcon className="w-5 h-5 mr-2 text-green-400" data-id="element-696" />
            <span className="text-sm font-medium" data-id="element-697">{message}</span>
          </div>
        </motion.div>}
    </AnimatePresence>;
}